import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";

import { ICampaign, ILeaderboardDetails } from "../../@types";
import {
  GET_VIEWER_LEADERBOARD_DETAILS,
  GET_CAMPAIGN,
} from "MVVM/GraphQL/campaign";
import { JOIN_CAMPAIGN } from "MVVM/GraphQL/competitions";

export const PlayViewModel = (campaign: string) => {
  const [isUserValidated, setIsUserValidated] = useState(false);

  const [getViewerLeaderboardDetails] = useLazyQuery<{
    campaign: {
      leaderboardDetails: {
        viewerContestant: ILeaderboardDetails["viewerContestant"];
        campaign: ILeaderboardDetails["campaign"];
      };
    };
  }>(GET_VIEWER_LEADERBOARD_DETAILS, {
    variables: { slug: campaign },
    fetchPolicy: "network-only",
  });

  const [joinCampaign] = useMutation(JOIN_CAMPAIGN, {
    variables: { campaign },
  });

  const { data, loading, error, refetch } = useQuery<{
    campaign: ICampaign;
  }>(GET_CAMPAIGN, {
    variables: { slug: campaign },
    skip: !campaign || !isUserValidated,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    const checkAndJoinCampaign = async () => {
      if (!campaign) return;

      const { data: leaderboardData } = await getViewerLeaderboardDetails();
      const viewerContestant =
        leaderboardData?.campaign?.leaderboardDetails?.viewerContestant;

      if (viewerContestant?.rank === -1) {
        await joinCampaign();
        await getViewerLeaderboardDetails();
      }

      setIsUserValidated(true);
    };

    checkAndJoinCampaign();
  }, [campaign, getViewerLeaderboardDetails, joinCampaign]);

  return {
    campaign: data?.campaign,
    loading,
    error,
    refetch,
    getViewerLeaderboardDetails,
    joinCampaign,
  };
};
